module.exports = __webpack_public_path__ + "img/se.2892c712.svg";